import { ScheduledSimulationType } from "@/constants/security-awareness.ts";

/**
 * Detects whether a BoxPhish scheduled simulation is a random-journey simulation.
 * Random simulations have no single previewable email, so callers should render them as plain text.
 * @param format - The `scheduledSimulationFormat` value from the BoxPhish item (case-insensitive).
 * @returns `true` if the format matches {@link ScheduledSimulationType.RANDOM_SIMULATION}; `false` for any other value, empty string, `null`, or `undefined`.
 */
export const isRandomSimulation = (format?: string | null): boolean =>
  !!format && format.toLowerCase() === ScheduledSimulationType.RANDOM_SIMULATION.toLowerCase();
